<template>
  <div class="quantity-component">
    <p class="body-text">{{ placeHolder }}</p>

    <div class="quantity-component-controls">
      <button class="quantity-component-controls-button" @click="handleChange(-1)" :disabled="val <= 1">
        <div class="minus-icon"></div>
      </button>
      <p class="body-text-bold">
        {{ val }}
      </p>
      <button class="quantity-component-controls-button" @click="handleChange(1)" :disabled="val >= 99">
        <div class="plus-icon"></div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, useAttrs } from 'vue';
const attrs = useAttrs();

const inputComponent = ref<HTMLInputElement | null>(null);

defineProps<{
  placeHolder: string;
}>();

const val = defineModel({
  type: Number,
  default: 1,
  required: true,
});

onMounted(() => {
  if (attrs['auto-focus']) {
    inputComponent.value?.focus();
  }
});

function handleChange(value: number) {
  const newValue = val.value + value;
  if (newValue >= 1 && newValue <= 99) {
    val.value += value;
  }
}
</script>
